import { SelectedProductsSlice } from 'featureSliced/shared/store/reducers/SelectedProductsReducer'
import { QRMBucketSlice } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer'
import { useMyDispatch } from '../useMyDispatch'
import { useOpenModal } from '../useOpenModal'
import { useTranslations } from '../useTranslations'
import { NoReceiptModal } from 'components/ReceiptModal/NoReceiptModal'

export type useOpenNoReceiptModalType = (numberToDisplay?: string) => void

export const useOpenNoReceiptModal = (): useOpenNoReceiptModalType => {
  // Hooks
  const dispatch = useMyDispatch()
  const openModal = useOpenModal()
  const t = useTranslations()

  // Store
  const { discardSelectedProducts } = SelectedProductsSlice.actions
  const clearBucket = QRMBucketSlice.actions.clearBucket

  // Functions
  const openNoReceiptModal = (numberToDisplay?: string) => {
    openModal({
      id: 'NO_RECEIPT_MODAL',
      // title: t('order.toMenu'),
      components: [
        ({ closeThisModal }) => (
          <NoReceiptModal
            paymentNumberProps={numberToDisplay}
            onCloseModal={() => {
              closeThisModal()
              clearLocalStorage()
              dispatch(discardSelectedProducts()) // TODO: deprecated. remove
              dispatch(clearBucket())
            }}
          />
        ),
      ],
      onClose: () => {
        clearLocalStorage()
        dispatch(discardSelectedProducts()) // TODO: deprecated. remove
        dispatch(clearBucket())
      },
    })
  }

  const clearLocalStorage = () => {
    window.localStorage.removeItem('products_notes')
    window.localStorage.removeItem('orderComment')
    window.localStorage.removeItem('pickUpDelay')
    window.localStorage.removeItem('pickUpTime')
  }

  return openNoReceiptModal
}
